<div class="dialog-content-wrapper">
    <mat-toolbar class="color-green m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>

        <form name="vinculoForm" [formGroup]="vinculoForm" class="event-form w-100-p" fxLayout="column" fxFlex>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center">
            
                <mat-form-field  appearance="outline" floatLabel="always" fxFlex="100" fxFlex.gt-sm="100">
                    <mat-label>Vínculo</mat-label>
                    <mat-select required name="tipoVinculo" formControlName="tipoVinculo" [disabled]="action === 'edit'">
                        <mat-option>
                            Selecione uma opção 
                        </mat-option>
                        <mat-option *ngFor="let enum of enumTipoCadastroVinculo" [value]="enum.value" disabled="{{desabilitaTipoVinculo(enum.value)}}">
                            {{enum.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" *ngIf="this.vinculoForm.get('tipoVinculo').value == 0">

                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" fxFlex.gt-sm="100">
                    <mat-label>Tipo de Despesa</mat-label>
                    <input matInput name="tipoDespesaAux"
                        formControlName="tipoDespesaAux" [matAutocomplete]="autoTipoDespesa"/>
                </mat-form-field>

                <mat-autocomplete #autoTipoDespesa="matAutocomplete" [displayWith]="displayTipo">
                    <mat-option *ngIf="isloadingTipoDespesa"><mat-spinner diameter="20"></mat-spinner></mat-option>
                    <ng-container style="z-index:1;" *ngIf="!isloadingTipoDespesa">
                        <mat-option *ngFor="let despesa of filteredTipoDespesa"
                            [value]="despesa">
                            <span>{{despesa.descricaoCadastro}}</span>
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
            
            </div>
            
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" *ngIf="this.vinculoForm.get('tipoVinculo').value == 1">

                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" fxFlex.gt-sm="100">
                    <mat-label>Tipo de Pagamento</mat-label>
                    <input matInput name="tipoPagamentoAux"
                        formControlName="tipoPagamentoAux" [matAutocomplete]="autoTipoPagamento"/>
                </mat-form-field>

                <mat-autocomplete #autoTipoPagamento="matAutocomplete" [displayWith]="displayTipo">
                    <mat-option *ngIf="isloadingTipoPagamento"><mat-spinner diameter="20"></mat-spinner></mat-option>
                    <ng-container style="z-index:1;" *ngIf="!isloadingTipoPagamento">
                        <mat-option *ngFor="let pagamento of filteredTipoPagamento"
                            [value]="pagamento">
                            <span>{{pagamento.descricaoCadastro}}</span>
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
            
            </div>
            
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center" *ngIf="this.vinculoForm.get('tipoVinculo').value == 2">

                <mat-form-field  appearance="outline" floatLabel="always" fxFlex="100" fxFlex.gt-sm="100">
                    <mat-label>Grupo de Usuário</mat-label>
                    <mat-select name="grupoAux" formControlName="grupoAux">
                        <mat-option> Selecione uma opção </mat-option>
                        <mat-option *ngFor="let grupo of gruposUsuarios" [value]="grupo">
                            {{grupo.userGroupName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center"
                style="margin-bottom: 20px;">
            
                <div style="white-space: nowrap !important;">
            
                    <mat-chip-list class="mat-chip-teste">
            
                        <mat-chip *ngFor="let vinculo of this._data.listReferencias" style="margin: 4px;" color="accent"
                            selected [selectable]="true" [removable]="true" (removed)="removeVinculo(vinculo)">
                            {{ vinculo.descricao }}
                            <mat-icon matChipRemove *ngIf="true">cancel
                            </mat-icon>
            
                        </mat-chip>
            
                    </mat-chip-list>
            
                </div>
            
            </div>

        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-raised-button color="accent"
                (click)="adicionar()"
                [disabled]="vinculoForm.invalid"
                aria-label="Adicionar">
            {{action === 'edit' ? 'Salvar' : 'Adicionar'}}
        </button>

    </div>

</div>
